export default __webpack_public_path__ + "static/media/accommodation2.8bb7573b.webp";